module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/合作.c9049928.png";